import React, { createContext, useContext, useState, ReactNode } from "react";

interface StripeClientSecretContextType {
  clientSecret: string | null;
  setClientSecret: (secret: string | null) => void;
}

const StripeClientSecretContext = createContext<
  StripeClientSecretContextType | undefined
>(undefined);

interface StripeClientSecretProviderProps {
  children: ReactNode;
}

export function StripeClientSecretProvider({
  children,
}: StripeClientSecretProviderProps) {
  const [clientSecret, setClientSecret] = useState<string | null>(null);

  return (
    <StripeClientSecretContext.Provider
      value={{ clientSecret, setClientSecret }}
    >
      {children}
    </StripeClientSecretContext.Provider>
  );
}

export function useStripeClientSecret() {
  const context = useContext(StripeClientSecretContext);
  if (context === undefined) {
    throw new Error(
      "useStripeClientSecret must be used within a StripeClientSecretProvider"
    );
  }
  return context;
}
